<template>
    <div class="record-row" :class="{ 'record-strip': strip, [`record-${tone}`]: tone }">
        <div class="record-cells"><slot /></div>
        <div v-if="$scopedSlots.note" class="record-note"><slot name="note" /></div>
    </div>
</template>

<script>
// cells go in a fixed order: amount, price, date, then an optional status or action
export default {
    name: 'RecordRow',
    props: {
        strip: Boolean,
        tone: String,
    },
};
</script>

<style>
.record-row {
    padding: 10px;
    border-top: 1px solid var(--sheet-divider);
    font-size: 13.5px;
}
.sheet-group > .record-row:first-child {
    border-top: 0;
}
.record-cells {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1.1fr 48px;
    column-gap: 6px;
    align-items: start;
}
.record-cells > * {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
/* with no status or action, the date takes the free column so a long date stays on one line */
.record-cells > :nth-child(3):last-child {
    grid-column: span 2;
}
.record-cells > :nth-child(4) {
    text-align: right;
}
.record-date {
    font-size: 12.5px;
    color: var(--sheet-date);
    padding-top: 1px;
}
.record-sub {
    font-size: 11.5px;
    margin-top: 1px;
    color: var(--sheet-muted);
}
.record-note {
    font-size: 12px;
    color: var(--sheet-muted);
    margin-top: 2px;
}
.record-strip {
    margin-top: 12px;
    padding: 11px 10px;
    border-top: 0;
    border-radius: 10px;
    background: var(--sheet-group);
    font-size: 15px;
}
.sheet-section-label + .record-strip {
    margin-top: 0;
}
.record-strip .record-date {
    font-size: 14px;
    color: #fff;
}
.record-muted,
.record-muted .record-date {
    color: var(--sheet-muted);
}
.record-match,
.record-match .record-date {
    color: #ffc107;
}
</style>
